export const getContractId = (chainId: number): string => chainId === 4 ? '0xD4506395C0F67BC6941A77c788ef4D3026Da6823' : ''
export const MAX_SUPPLY = 2500

export const INFURA_ID = '288d3145859e45dca9d1c701fce7113e'
export const VALID_CHAIN_IDS = [1, 4]
